import { useContext } from 'react';
import { AuthContext } from '@/contexts/AuthContext';

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  const {
    user,
    profile,
    isLoading,
    isInitialized,
    signIn,
    signOut,
    signUp,
    updatePassword
  } = context;

  return {
    user,
    profile,
    isLoading,
    isInitialized,
    signIn,
    signOut,
    signUp,
    updatePassword,
  };
} 